// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Shimmer_shimmer__1FE-W","fade":"Shimmer_fade__3NnA2"};